	<template>
	<div>
		<div v-if="notificationLoading" style="position:absolute; top:0; right:0; bottom:0; left:0; padding-top: 25%;background-color:rgba(255,255,255,0.31)">
          <div class="text-xs-center">
            <v-progress-circular
                :size="70"
                :width="7"
                indeterminate
                color="white"
                class="text-xs-center my-5"
                large
            ></v-progress-circular>
          </div>
      </div>  
		<v-container fluid grid-list-md class="padding_10" v-else>
		   <v-layout class="index_header">
		     <v-flex xs12 md6>
		     </v-flex>
		     <v-flex xs12 md6 class="text-xs-right">		 
		     </v-flex>
		   </v-layout>
		    
     <!--  <v-layout class="index_header table_opacity_8">
		    <v-flex xs12 class="text-xs-right" mt-3>
		       	<v-menu offset-y >
	                <v-btn slot="activator" color="#2ce0cf" >
	                 <v-icon color="white">more_vert</v-icon>Action
	                </v-btn>
	                <v-list>
		                <v-list-tile >
		                  <v-list-tile-title :style="selected.length ? 'cursor:pointer;' : ''" @click="sendNotification">Send Notification</v-list-tile-title>
		                </v-list-tile>   
	                </v-list>
                </v-menu>  
		    </v-flex>
		  </v-layout> -->
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12>
        	<v-data-table
	        	no-results-text="Loading... Please wait"
			    :headers="headers"
			    v-model="selected"
			    :items="device_list"
			    item-key="id"
			    :loading="loaders.office_list_loader"
			    select-all
			   	:total-items="total_items"
			   	:rows-per-page-items="[10,20,50,100]"
		   >
		   <template v-slot:headers="props">
		        	<tr>
		        	    <th style="padding: 0 10px;">
		        	    	
		          		</th>
		          <th
		            v-for="header in props.headers"
		            :key="header.text"
		            :class="[header.sortable !== false ? 'column sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
		            @click="changeSort(header)"
		          >
		            {{ header.text }}
		            <v-icon small v-if="header.sortable !== false">arrow_upward</v-icon>
		          </th>
		        </tr>
		       
    		</template>
		    <template slot="items" slot-scope="props">
		    	<td style="padding: 0 10px;">
		            <v-checkbox 
		               v-model="props.selected"
		               primary
		               hide-details
		               :readonly="is_selected_all"
		            ></v-checkbox>
          		</td>
		    	<td>
		    			{{props.item.user.last_name}}
		    	</td>
		    	<td>
		    		{{props.item.health_logs.battery_health}}
		    	</td>
		    	<td>
		    		{{props.item.health_logs.battery_level}}
		    	</td>
		    	<td>
		    		{{props.item.health_logs.battery_status}}
		    	</td>
		    	<td>
		    		{{props.item.health_logs.battery_temperature}}
		    	</td>
		    	<td>
		    		{{props.item.health_logs.battery_voltage}}
		    	</td>
		    	<td>
		    		{{props.item.health_logs.network_status}}
		    	</td>
		    	<td>
		    		{{props.item.health_logs.network_source}}
		    	</td>
		    	<td>
		    		{{props.item.health_logs.display_brightness}}
		    	</td>
		    	<td>
		    		{{props.item.health_logs.display_brightness_mode}}
		    	</td>
		    	<td>
		    		{{props.item.health_logs.display_orientation}}
		    	</td>
		    	<td>
		    		{{props.item.health_logs.ram_usage}}
		    	</td>
		    	<td>
		    		{{props.item.health_logs.ram_usage_percent}}
		    	</td>
		    	<td>
		    		{{props.item.health_logs.cpu_usage_percent}}
		    	</td>
		    	<td>
		    		{{props.item.health_logs.temperature_battery}}
		    	</td>
		    	<td>
		    		{{props.item.health_logs.temperature_cpu}}
		    	</td>
		    	<td>
		    		{{props.item.health_logs.updated_at}}
		    	</td>

		    </template>
		    <template slot="no-data">
		    	<v-layout row wrap justify-center class="text-xs-center" v-if="loaders.office_list_loader">
		    	  Loading... Please wait
		    	</v-layout>
		    	<v-layout row wrap justify-center class="text-xs-center" v-else>
		    	  No data available
		    	</v-layout>
		    </template>
		   </v-data-table>
          
        </v-flex>
      </v-layout>
	<!-- Delete Resource dialog box -->
		   <v-dialog
			    v-model="delete_model"
			    scrollable 
			    :overlay="false"
			    max-width="500px"
			    transition="dialog-transition"
			    persistent
			    >
    		<v-card>
		      <v-form>
		        <v-card-text>
		          <v-layout row wrap>
		           <v-flex xs12 md12 lg12>
		           <h3>Are you sure you want to delete the announcement?</h3>
		          </v-flex>
		        </v-layout>
		      </v-card-text>
		      <v-card-actions>
		        <v-spacer></v-spacer>
		        <v-btn small color="primary" @click="confirmDelete">Delete</v-btn>
		        <v-btn small color="black" flat type="reset" @click="delete_model = !delete_model">Cancel</v-btn>
		        
		      </v-card-actions>
		    </v-form>
  		</v-card>
		</v-dialog>

		   <v-snackbar
		  	:timeout="snack_bar.timeout"
           	:color="snack_bar.color"
         	:top="snack_bar.top"
         	:bottom="snack_bar.bottom"
         	:left="snack_bar.left"
         	:right="snack_bar.right"
         	v-model="snack_bar.show"
        	 >
         		{{ snack_bar.message }}
         	<v-btn dark flat @click.native="snack_bar.show = false">
           		<v-icon>close</v-icon>
         	</v-btn> 
		   </v-snackbar>

		</v-container>
	</div>
</template>
<script>
	import { mapGetters } from 'vuex'
	export default
	{
		
		created(){},
		computed:{
			...mapGetters({
			  office_location: 'get_office_location'
			})
		},
		watch:{
			pagination:{
				handler()
				{
					this.getList();
				}
			}
		},
		methods:{
			getList:function()
			{
				this.loaders.office_list_loader =  true;
				this.pagination.filters = Object.assign({},this.filters);
				axios.get(`${process.env.VUE_APP_API_URL}/api/v1/train-devices`,{ params: this.pagination,headers:this.$headers}).then((response)=>{
					if(response.data.status ==1)
					{
						this.device_list = response.data.train_devices;
						this.total_items = response.data.train_devices.total;						
					}
				}).catch((error)=>{
					console.log(error);
					this.snack_bar.message="Error Occured";
					this.snack_bar.show;
				}).finally(()=>{{
					this.loaders.office_list_loader = false;
				}});

				this.is_loading = false;
			},
			 
			clearFilter:function(filter,key)
    		{
      			this.filter_chips[key] = this.filters[key] = '';
      			this.filterList();
    		},
			resetFilter()
			{	
				this.$router.replace({
					name:'offices',
					query:{}
				});
				this.getList();
				this.resetFiltersParameters();
				this.is_filtered = false;
				this.filter_dialog_box = false;
				// this.snack_bar.message = "Filter Reset.";
				// this.snack_bar.show = true;
			},
			resetFiltersParameters:function()
	   		{
	      		for( var key in this.filters)
	      		{
	        		this.filters[key]='';
	        		this.filter_chips[key] = '';
	        	}
	      	},
	      	applyFiltersOnLoad:function()
    		{
       			this.filters.name = this.$route.query.name;
		       	this.filters.address = this.$route.query.address;
		       	this.displayFilterChips(this.filters);
       		},
       		displayFilterChips:function(filters)
      		{
      			if(this.$route.query.filters)
      			{
        			this.filter_chips.name = filters.name;
        			this.filter_chips.address = filters.address; 
        			this.is_filtered = true;
      			}
    		},
			validateBeforeSubmit:function(scope)
			{
				this.$validator.validateAll(scope).then(result =>{
					if(result)
					{
						this[scope]();
					}
				});
			},
			toggleAll () {
		        if (this.selected.length) {
		        	this.selected = []
		        } else {
		        	this.selected = this.device_list.slice()
		        }
		        this.is_selected_all = false;
      		},
			togglePages() {
      			this.is_selected_all= !this.is_selected_all;
      			if(this.is_selected_all)
      			{
      				this.selectAll();
      				this.all_selected_items=[];
      			}
      			else
      			{	
      				this.selected = []
      			}	
      		},
      		selectAll(){
      			this.selected = this.device_list.slice()
      		},
      		
		    pageSelect(){
		    	this.toggleAll();
		    },
		    deselectAll()
		    {
		    	this.selected=[];
		    	this.is_selected_all=false;
		    	this.all_selected_items=[];
		    },
		    sendNotification(){
		    	if(this.selected.length) 
		    	{
		    		this.notificationLoading = true;
		    		let selectedIds = this.selected.map(s => s.id);
      			    let data = {
				       "announcement_ids": selectedIds
				    }
			       axios.post(`${process.env.VUE_APP_API_URL}/api/v1/send-notification`, data,{headers:this.$headers})
			                    .then(response => {
			                    	if(response.data.status == 1){
			                    	  this.selected=[];
									  this.notificationLoading = false;
									  this.snack_bar.message=response.data.message;
					                  this.snack_bar.show =true;
			                    	}						          
						        })
						        .catch(error => {
									this.exportLoading = false;
						          console.log(error) 
						        });
			    	
			    }
		    },
		    deleteAnnouncement:function(item){
		    	this.announcement_item = item;
    			this.delete_model = true;
		    },
		    confirmDelete:function()
    		{
    			this.notificationLoading = true;
    			axios.post(`${process.env.VUE_APP_API_URL}/api/v1/delete-announcement`, {announcement_id:this.announcement_item.id},{headers:this.$headers}).then((response)=>{
    				
					if(response.data.status == 1)
					{
						this.notificationLoading = false;
						this.delete_model =false;
						this.snack_bar.message = response.data.message;
          				this.snack_bar.show = true;
						
					}
					
				}).catch((error)=>{
				
				}).finally(()=>{
					
				});	
    		},
		},
		data:() => {
			return{
				announcement_item:{},
				delete_model:false,
				is_selected_all:false,
				all_selected_items:[],
				selected: [],
				is_filtered:false,
				notificationLoading:false,
				filter_key_count :-1,
				pagination:{sortBy:"created_at",descending:false,rowsPerPage: 10},
				filters:{
					status:'',
				},
				filter_chips:{
					name:'',
					address:'',
				},
				filter_dialog_box:false,
				snack_bar:{
					show:false,
					message:'',
					timeout:4000,
					top:true,
					right:true,
					bottom:false,
					left:false,
					color:'',
				},
				total_items:0,
				
				headers:[
				{
					text:"Device User",
					value:"user_id",
					align:"left",
					sortable:true,
				},
				{
					text:"Battery Health",
					value:"battery_health",
					align:"left",
					sortable:true,
				},
				{
					text:"Battery Level",
					value:"battery_level",
					align:"left",
					sortable:false,	
				},
				{
					text:"Battery Status",
					value:"battery_status",
					sortable:false,
				},
				{
					text:"Battery Temperature",
					value:"battery_temperature",
					sortable:false,
				},
				{
					text:"Battery Voltage",
					value:"battery_voltage",
					sortable:false,
				},
				{
					text:"Network Status",
					value:"network_status",
					sortable:false,
				},
				{
					text:"Network Source",
					value:"network_source",
					sortable:false,
				},
				{
					text:"Display Brightness",
					value:"display_brightness",
					sortable:false,
				},
				{
					text:"Display Brightness Mode",
					value:"display_brightness_mode",
					sortable:false,
				},
				{
					text:"Display Orientation",
					value:"display_orientation",
					sortable:false,
				},
				{
					text:"RAM Usage",
					value:"ram_usage",
					sortable:false,
				},
				{
					text:"RAM Usage %",
					value:"ram_usage_percent",
					sortable:false,
				},
				{
					text:"CPU Usage %",
					value:"cpu_usage_percent",
					sortable:false,
				},
				{
					text:"Temperature Battery",
					value:"temperature_battery",
					sortable:false,
				},
				{
					text:"Temperature CPU",
					value:"temperature_cpu",
					sortable:false,
				},
				{
					text:"Updated AT",
					value:"updated_at",
					sortable:false,
				},
				
				],
				device_list:[],
				add_new_office_model:false,
				new_office: {
					name: ''
				},
				loaders:{
					office_list_loader:false,
					new_office_submit_loader:false,
				},
				 auth_user:{
			        roles:[{}]
			      },
			}
		},
		mounted() {
			this.getList();
			this.applyFiltersOnLoad();
			this.auth_user = this.$store.getters.get_user;
			// console.log(this.auth_user)
		}
	};
</script>
